// helper module to isolate real storage of LinkSoft global settings.
export default () => {
    if(typeof window.linksoft !== 'object') {
        window.linksoft = {};
    }
    return window.linksoft;
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/internal/config.js